<div *ngIf="!mostrarFormulario" class="row animated fadeInRight">
  <!-- *FORMULARIO -->
  <app-lfsa-card-v2
    [innTemplate]="enviarTemplateEdit" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>

  <ng-template #enviarTemplateEdit>
    <form [formGroup]="formulario" class="form-group" novalidate>
      <div class="row">
        <div *ngIf="!loading" class="form-group col-md-6">
          <app-lfsa-input [control]="formulario.get('idParametro') | formControl" [id]="'idParametro'"
                          [isReadOnly]="true" [label]="'ID*'" [mostrarImg]="false"
                          [placeholder]="'ID'"
                          [rutaImagen]=""
                          [type]="'number'"
                          formControlName="idParametro">
          </app-lfsa-input>
        </div>
        <div *ngIf="!loading" class="form-group col-md-6">
          <app-lfsa-combo-box [comboBox]="cmbOrganizacionVenta"
                              [control]="formulario.get('idOrgaVenta') | formControl"
                              [idOpcion]="'id'"
                              [id]="'idOrgaVenta'"
                              [label]="'Organización de Venta*'"
                              [opcion]="'descripcion'"
                              formControlName="idOrgaVenta">
          </app-lfsa-combo-box>
        </div>
        <div *ngIf="!loading" class="form-group col-md-6">
          <app-lfsa-combo-box [comboBox]="cmbCanalVenta"
                              [control]="formulario.get('idCanalVenta') | formControl"
                              [idOpcion]="'id'"
                              [id]="'idCanalVenta'"
                              [label]="'Canal de Venta*'"
                              [opcion]="'descripcion'"
                              formControlName="idCanalVenta">
          </app-lfsa-combo-box>
        </div>
        <div *ngIf="!loading" class="form-group col-md-6">
          <app-lfsa-combo-box [comboBox]="cmbSectorVenta"
                              [control]="formulario.get('idSectorVenta') | formControl"
                              [idOpcion]="'id'"
                              [id]="'idSectorVenta'"
                              [label]="'Sector de Venta*'"
                              [opcion]="'descripcion'"
                              formControlName="idSectorVenta">
          </app-lfsa-combo-box>
        </div>

        <div *ngIf="!loading" class="form-group col-md-6 mb-2 d-flex align-items-center">
          <ng-container>
            <a #btnAddCliente class="btn btn-primary" data-bs-target="#clienteModal" data-bs-toggle="modal"
               role="button">
              <span>Seleccionar Cliente</span>
              <i class="fa fa-tags"></i>
            </a>
          </ng-container>
        </div>
        <div *ngIf="!loading" class="form-group col-md-6 mb-2">
          <app-lfsa-input [control]="formulario.get('nombreCliente') | formControl"
                          [id]="'nombreCliente'" [isReadOnly]="true" [label]="'Nombre Cliente*'"
                          [mostrarImg]="false"
                          [placeholder]="'Nombre Cliente'"
                          [rutaImagen]=""
                          formControlName="nombreCliente">
          </app-lfsa-input>
        </div>

      </div>
      <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )" [botonRegresar]="false"
                                   [formularioValido]="formulario.invalid"
                                   [loading]="loading" [textBoton]="textBoton">
      </app-lfsa-botones-formulario>
    </form>
  </ng-template>
</div>

<ng-container>
  <app-cliente-modal (onSelect)="clienteSelected($event)"></app-cliente-modal>
</ng-container>
